import React from 'react';
import {Box, Grid, Button, Stack, TextareaAutosize, Typography} from '@mui/material'; 
import { toast, ToastContainer } from 'react-toastify';
import FormManager from '../../../../components/formComponents/FormManager';
import schema from './schema.json'; 

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import * as moment from 'moment'; 

import HTTPManager from '../../../../utils/httpRequestManager';

export default class MerchantReview extends React.Component{
    httpManager = new HTTPManager();
    constructor(){
        super();
        this.state={ 
            schema: schema,
            notes:'',
            isLoading: false,
            isNotesLoading: false,
            notesList:[]
        }

        this.saveNotes = this.saveNotes.bind(this);
        this.approveMerchant = this.approveMerchant.bind(this);
        this.rejectMerchant = this.rejectMerchant.bind(this);
    }

    componentDidMount(){
        //console.log(this.props.toReview)
        this.setFormDetails()
        this.reloadData();
    }


    setFormDetails(){
        this.setState({isLoading: true})
        var data = Object.assign({}, this.props.toReview);
        var schema = Object.assign({}, this.state.schema);
        var propslist = Object.assign([], this.state.schema.properties);
        var properties = [];
        propslist.forEach((field, i)=>{ 
            field.value = data[field.name];
            properties.push(field);
            if(i === propslist.length-1){
                properties.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })

                schema.properties = properties
                this.setState({schema: schema},()=>{
                    this.setState({isLoading: false})
                })
            }
        })
    }

    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isNotesLoading: true},()=>{
            this.httpManager.postRequest(`merchant/notes/getNotes`, {merchantId: this.props.toReview.id}).then(response=>{ 
                if(response.data.length > 0){
                    this.setState({notesList:response.data, isNotesLoading: false})
                }
                else{
                    this.setState({notesList:[], isNotesLoading: false});
                }
            })
        })
    }

    saveNotes(){
        var input = {
            merchantId: this.props.toReview.id,
            notes: this.state.notes
        }
        this.httpManager.postRequest(`merchant/notes/saveNote`, input).then(res=>{
            this.setState({notes:''})
            this.reloadData(res.message)
        })
    }

    renderNotes(){
        const height = (window.innerHeight - 300)+"px";

        return  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{display:'inline', width:'100%', margin:'1rem'}}> 

            <List sx={{ width: '100%', maxHeight:height, overflowY:'scroll'}}>
                {this.state.notesList.map(e=>{
                        return <>
                        <ListItem alignItems="flex-start"> 
                        <ListItemText
                            primary={<React.Fragment>
                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                            <Typography
                                sx={{ display: 'inline', color:'#000', fontWeight:500 }}
                                component="span"
                                variant="body2" 
                            > 
                            {e.createdBy}
                            </Typography>

                            <Typography
                                sx={{ display: 'inline', color:'#000', fontWeight:500, fontSize:'12px' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                                >  {moment(e.createdDate).format('MM/DD/YYYY hh:mm:ssa')}
                                </Typography>
                                </div>
                            </React.Fragment>}
                            secondary={
                            <React.Fragment> 
                                {e.notes}
                            </React.Fragment>
                            }
                        />
                        </ListItem>
                        <Divider style={{'marginLeft':0}} variant="inset" component="li" />
                        </>
                })
                }

                {
                this.state.notesList.length === 0 && <>
                <ListItem alignItems="flex-start" style={{paddingLeft:0}}> 
                <ListItemText
                    primary={<React.Fragment>
                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <Typography
                        sx={{ display: 'inline', color:'#000', fontWeight:500 }}
                        component="span"
                        variant="body2" 
                    >  
                    </Typography> 
                        </div>
                    </React.Fragment>}
                    secondary={
                    <React.Fragment> <Typography
                    sx={{ display: 'inline',  fontSize:'12px'}}
                    component="span"
                    variant="body2" 
                    >  
                        No notes added yet.
                        </Typography>
                    </React.Fragment>
                    }
                />
                </ListItem>
                <Divider style={{'marginLeft':0}} variant="inset" component="li" />
                </>
                }

                </List>
            {/* </div> */}
            {/* </Grid> */}
        </Stack>
    }

    approveMerchant(formData){
        this.props.showLoader()
        this.httpManager.postRequest("merchant/process/updateMerchant", formData).then(r=>{
            var input = {
                id: this.props.toReview.id,
                merchantStatus:'Verified',
                ownerPasscode: formData.ownerPasscode
            }
            this.httpManager.postRequest('merchant/verify/approveMerchant', input).then(res=>{
                this.props.reloadData(res.message)
            })
        })
    }

    rejectMerchant(){
        var input = {
            id: this.props.toReview.id,
            merchantStatus:'Rejected'
        }
        this.httpManager.postRequest('merchant/verify/rejectMerchant', input).then(res=>{
            this.props.reloadData(res.message)
        })
    }

    render(){
        return <>    
            {<Box sx={{ width: '100%' }}> 
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />

                <Grid container spacing={3}  alignItems="flex-start"  justifyContent="center" flexDirection={'row'} style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} >  
                     <Grid item xs={7}>

                        <Stack spacing={3}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                <Button  onClick={()=>this.goToPlan()} label="Go Back"/>  
                            </Stack> 
                            {!this.state.isLoading && <FormManager formProps={this.state.schema} reloadData={()=>{
                                this.props.reloadData()
                            }} closeForm={(action='', formData={})=>{
                                //console.log(action, formData)
                                if(action === ''){
                                    this.props.closeReview()
                                }
                                if(action==='Approve'){
                                    this.approveMerchant(formData);
                                }
                                if(action === 'Reject'){
                                    this.rejectMerchant();
                                }
                            }}/> }
                        </Stack>
                    </Grid>
                    <Grid item xs={5} style={{marginTop:'100px'}}>
                        <TextareaAutosize
                            fullWidth
                            maxRows={10} 
                            placeholder="Add Note"
                            required 
                            value={this.state.notes}  
                            className='notesarea'
                            onChange={(e)=>{
                                this.setState({notes:e.target.value})
                            }}
                        />

                        <Button variant="contained" disabled={this.state.notes === ''} onClick={()=>{
                            this.saveNotes()
                        }}>Add</Button>

                        {this.renderNotes()}
                    </Grid> 
                </Grid>

            </Box>}
        </>
    }
}